module.exports = "<span *ngIf=\"errorFieldName\" class=\"fieldErrorMessage\">{{errorFieldName}}</span>"